import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { UIModule } from 'src/app/shared/ui/ui.module';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { OrdersRoutingModule } from './orders-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbDropdownModule, NgbModalModule, NgbModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxPaginationModule } from 'ngx-pagination';
import { CoreModule } from 'src/app/core/core.module';


@NgModule({
  declarations: [
    OrdersListComponent,
    OrderSummaryComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OrdersRoutingModule,
    NgxIntlTelInputModule,
    UIModule,
    SharedModule,
    Daterangepicker,
    NgbDropdownModule,
    NgxPaginationModule,
    NgbTypeaheadModule,
    NgbCollapseModule,
    NgbModalModule,
    NgbModule,
    NgSelectModule,
  ],
  exports: [OrdersListComponent] // Export the component to make it available in other modules
  // providers: [LocationsService, TitleCasePipe]
})
export class OrdersModule { }
